var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "bj-query-form bj-query-form-for-cal-height form",
      attrs: { size: "mini", model: _vm.form, rules: _vm.rules },
    },
    [
      _c(
        "el-row",
        { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.Client"),
                    prop: "clientCode",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.clientCodeList,
                      placeholder: _vm.$t("chooseText"),
                    },
                    on: { change: _vm.getCategoryCodeList },
                    model: {
                      value: _vm.form.clientCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "clientCode", $$v)
                      },
                      expression: "form.clientCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.Category"),
                    prop: "categoryCode",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.categoryCodeList,
                      placeholder: _vm.$t("chooseText"),
                    },
                    on: { change: _vm.clearValidator },
                    model: {
                      value: _vm.form.categoryCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "categoryCode", $$v)
                      },
                      expression: "form.categoryCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.quantity"),
                    prop: "quantity",
                  },
                },
                [
                  _c("BjInputMoney", {
                    attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                    model: {
                      value: _vm.form.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "quantity", $$v)
                      },
                      expression: "form.quantity",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.PurchaseOrder"),
                    prop: "poId",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                      disabled: _vm.poDIS,
                    },
                    on: { change: _vm.poDISFUN },
                    model: {
                      value: _vm.form.poId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "poId", $$v)
                      },
                      expression: "form.poId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.OrderNumber"),
                    prop: "orderId",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                      disabled: _vm.orderDIS,
                    },
                    on: { change: _vm.orderDISFUN },
                    model: {
                      value: _vm.form.orderId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orderId", $$v)
                      },
                      expression: "form.orderId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.ReturnOrder"),
                    prop: "returnOrderId",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                      disabled: _vm.returnOrderDIS,
                    },
                    on: { change: _vm.returnOrderDISFUN },
                    model: {
                      value: _vm.form.returnOrderId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "returnOrderId", $$v)
                      },
                      expression: "form.returnOrderId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.yearAndWeek"),
                    prop: "year",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      id: "getWeekDate",
                      "picker-options": { firstDayOfWeek: 1 },
                      type: "week",
                      format: "yyyy-WW",
                      clearable: false,
                      placeholder: _vm.$t("billingPage.yearAndWeeks"),
                    },
                    on: { change: _vm.dataChange },
                    model: {
                      value: _vm.weekDataNow,
                      callback: function ($$v) {
                        _vm.weekDataNow = $$v
                      },
                      expression: "weekDataNow",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.invoiceNumber"),
                    prop: "invoiceId",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                      disabled: _vm.returnOrderDIS,
                    },
                    model: {
                      value: _vm.form.invoiceId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "invoiceId", $$v)
                      },
                      expression: "form.invoiceId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _vm.LogisticRulesList.includes(_vm.form.categoryCode)
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.LogisticService"),
                        prop: "logisticsBusinessName",
                        rules: {
                          required: true,
                          message: this.$t("chooseText"),
                          trigger: "change",
                        },
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.LogisticsSelectionData,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.form.logisticsBusinessName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "logisticsBusinessName", $$v)
                          },
                          expression: "form.logisticsBusinessName",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.LogisticService"),
                        prop: "logisticsBusinessName",
                        rules: {
                          required: false,
                          message: this.$t("chooseText"),
                          trigger: "change",
                        },
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.LogisticsSelectionData,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.form.logisticsBusinessName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "logisticsBusinessName", $$v)
                          },
                          expression: "form.logisticsBusinessName",
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _vm.LogisticRulesList.includes(_vm.form.categoryCode)
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.TrackingNo"),
                        prop: "consignmentNo",
                        rules: {
                          required: true,
                          message: this.$t("inputText"),
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.consignmentNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "consignmentNo", $$v)
                          },
                          expression: "form.consignmentNo",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.TrackingNo"),
                        prop: "consignmentNo",
                        rules: {
                          required: false,
                          message: this.$t("inputText"),
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.consignmentNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "consignmentNo", $$v)
                          },
                          expression: "form.consignmentNo",
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan * 2 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.description"),
                    prop: "description",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      "show-word-limit": "",
                      maxlength: _vm.MAX_LENGTH.BILLMAX,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }